import { useEffect } from 'react';
import SwaggerUI from 'swagger-ui-react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';

import { setPageStatus } from '../../redux/swaggerApi/swaggerApi';
import useResponsive from '../../hooks/useResponsive';
import ApiVersions from './ApiVersions';
import {
  BaseLayout,
  OperationTag,
  AuthorizeOperationBtn,
  AuthorizeBtn,
  TryItOutButton,
  Info,
  Models,
  ModelCollapse,
  OperationSummary,
  Response,
  Responses,
  Execute,
  Parameters,
  ParameterRow,
  Operation,
  ModelExample,
  ObjectModel,
  ArrayModel,
  Property,
  EnumModel,
  PrimitiveModel,
  Curl,
  HighlightCode,
  TextArea,
  LiveResponse,
  Auths,
  HttpAuth,
  AuthorizationPopup,
  Clear
} from '../../components/Swagger';


const LivePlugin = () => {
  return {
    components: {
      BaseLayout,
      operation: Operation,
      OperationTag,
      modelExample: ModelExample,
      ObjectModel,
      ArrayModel,
      PrimitiveModel,
      EnumModel,
      OperationSummary,
      ModelCollapse,
      responses: Responses,
      response: Response,
      Models,
      curl: Curl,
      highlightCode: HighlightCode,
      authorizeOperationBtn: AuthorizeOperationBtn,
      authorizeBtn: AuthorizeBtn,
      TryItOutButton,
      TextArea,
      liveResponse: LiveResponse,
      info: Info,
      authorizationPopup: AuthorizationPopup,
      auths: Auths,
      HttpAuth,
      Property: Property,
      execute: Execute,
      parameters: Parameters,
      parameterRow: ParameterRow,
      clear: Clear
    },
  };
};

const MyWrapActionPlugin = function (system) {
  return {
    statePlugins: {
      auth: {
        wrapActions: {
          showDefinitions: (oriAction, system) => (data) => {
            // here, you can hand the value to some function that exists outside of Swagger UI
            return oriAction(data); // don't forget! otherwise, Swagger UI won't update
          },
        },
      },
    },
  };
};

function scrollTop(node, isMobile) {
  const shift = isMobile ? 80 : 10;
  window.scrollTo({
    top: node.offsetTop + shift,
    behavior: 'smooth',
  });
}

function SwaggerUiApi(props) {
  const { url, setPageStatus, history } = props;
  const { isMobile } = useResponsive();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/docs/apis' || location.pathname === '/docs/apis/') {
      history.replace('/docs/apis/identity');
    }
  }, []);

  useEffect(() => {
    const hash = location.hash.replaceAll(' ', '%20');
    const els = document.querySelectorAll(`a[href="${hash}"]`);
    if (els.length > 0 && hash) {
      const el = els[0];

      el.click();
      setTimeout(() => {
        scrollTop(el, isMobile);
      }, 50);
    }
  }, [location]);

  if (!url) return null;

  return (
    <>
      <ApiVersions location="swagger" />
      <SwaggerUI
        syntaxHighlight={{ activated: false }}
        url={url}
        // tryItOutEnabled={true}
        withCredentials={true}
        deepLinking={true}
        plugins={[LivePlugin, (system) => MyWrapActionPlugin(system)]}
        onComplete={() => setPageStatus({ status: true })}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  url: state.swaggerApi.url,
});

const mapDispatchToProps = {
  setPageStatus
};

export default connect(mapStateToProps, mapDispatchToProps)(SwaggerUiApi);
